var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 12H12V11H12.8C13 11 13.2 10.9 13.3 10.8C13.4 10.7 13.5 10.5 13.5 10.3V5.3C13.5 5.1 13.4 4.9 13.3 4.8C13.2 4.7 13 4.6 12.8 4.6H3.2C3 4.6 2.8 4.7 2.7 4.8C2.6 4.9 2.5 5.1 2.5 5.3V10.3C2.5 10.5 2.6 10.7 2.7 10.8C2.8 10.9 3.1 11 3.3 11H4V12H3.2C2.7 12 2.3 11.8 2 11.5C1.7 11.2 1.5 10.7 1.5 10.3V5.3C1.5 4.8 1.7 4.3 2 4C2.3 3.7 2.8 3.5 3.2 3.5H12.7C13.2 3.5 13.6 3.7 13.9 4C14.2 4.3 14.4 4.8 14.4 5.2V10.2C14.4 10.7 14.2 11.1 13.9 11.4C13.6 11.7 13.2 12 12.8 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 14.5H4.8C4.1 14.5 3.5 13.9 3.5 13.2V8.2C3.5 7.6 4.1 7 4.8 7H11.3C12 7 12.6 7.6 12.6 8.3V13.3C12.5 13.9 11.9 14.5 11.2 14.5ZM4.8 8C4.6 8 4.5 8.1 4.5 8.3V13.3C4.5 13.4 4.6 13.6 4.8 13.6H11.3C11.4 13.6 11.6 13.5 11.6 13.3V8.3C11.6 8.2 11.5 8 11.3 8H4.8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4H11.5V3.2C11.5 3 11.4 2.8 11.3 2.7C11.2 2.6 11 2.5 10.8 2.5H5.2C5 2.5 4.8 2.6 4.7 2.7C4.6 2.8 4.5 3.1 4.5 3.3V4H3.5V3.2C3.5 2.8 3.7 2.3 4 2C4.3 1.7 4.8 1.5 5.2 1.5H10.7C11.2 1.5 11.6 1.7 11.9 2C12.2 2.3 12.4 2.8 12.4 3.2V4H12.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 6.5C12.6 6.5 13 6.2 13 5.7C13 5.2 12.7 5 12.2 5C11.7 5 11.4 5.3 11.4 5.8C11.4 6.3 11.8 6.5 12.2 6.5Z",
    fill: "#505762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.f5db994cf908ffecfc5c2bdb24731541.svg";
export { ForwardRef as ReactComponent };